import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LISTA_VIDEOS,
  CRIA_VIDEO,
  EDITA_VIDEO,
  DELETA_VIDEO,
  TOGGLE_ATIVO_VIDEO,
} from 'constants/ActionTypes';
import api from 'util/ApiComunicacao';
import {
  listaVideosSucesso,
  listaVideosErro,
  criaVideoSucesso,
  editaVideoSucesso,
  deletaVideoSucesso,
  toggleAtivoVideoSucesso,
  videosErro,
} from 'actions/Videos';

/*#################################################################################################################*/
/* ------------------------------------------- Requests tipo GET --------------------------------------------------*/

const getVideos = async (pagina, tamanhoPagina, busca) => {
  const params = new URLSearchParams({ pagina, tamanhoPagina });
  if (busca) params.append('busca', busca);
  return api.get(`/v1/videos?${params}`).then(r => r).catch(e => e);
};

/*#################################################################################################################*/
/* ------------------------------------------ Requests tipo POST --------------------------------------------------*/

const postVideo = async (formData) =>
  api.post('/v1/videos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------------- Requests tipo PUT --------------------------------------------------*/

const putVideo = async (id, formData) =>
  api.put(`/v1/videos/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------- Requests tipo DELETE -------------------------------------------------*/

const deleteVideo = async (id) =>
  api.delete(`/v1/videos/${id}`).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ------------------------------------------ Requests tipo PATCH -------------------------------------------------*/

const patchToggleAtivo = async (id) =>
  api.patch(`/v1/videos/${id}/ativo`).then(r => r).catch(e => e);

/*#################################################################################################################*/
/* ----------------------------------------------- Sagas ----------------------------------------------------------*/

function* listarSaga({ payload }) {
  try {
    const { pagina, tamanhoPagina, busca } = payload;
    const result = yield call(getVideos, pagina, tamanhoPagina, busca);
    if (result.response && result.response.status >= 400) {
      yield put(listaVideosErro('Erro ao carregar vídeos.'));
    } else {
      yield put(listaVideosSucesso(result.data));
    }
  } catch (error) {
    yield put(listaVideosErro('Erro ao carregar vídeos.'));
  }
}

function* criarSaga({ payload }) {
  try {
    const result = yield call(postVideo, payload);
    if (result.response && result.response.status >= 400) {
      const msg = result.response.data?.notifications?.[0]?.message || 'Erro ao criar vídeo.';
      yield put(videosErro(msg));
    } else {
      yield put(criaVideoSucesso());
    }
  } catch (error) {
    yield put(videosErro('Erro ao criar vídeo.'));
  }
}

function* editarSaga({ payload }) {
  try {
    const result = yield call(putVideo, payload.id, payload.formData);
    if (result.response && result.response.status >= 400) {
      const msg = result.response.data?.notifications?.[0]?.message || 'Erro ao editar vídeo.';
      yield put(videosErro(msg));
    } else {
      yield put(editaVideoSucesso());
    }
  } catch (error) {
    yield put(videosErro('Erro ao editar vídeo.'));
  }
}

function* deletarSaga({ payload }) {
  try {
    const result = yield call(deleteVideo, payload.id);
    if (result.response && result.response.status >= 400) {
      yield put(videosErro('Erro ao excluir vídeo.'));
    } else {
      yield put(deletaVideoSucesso());
    }
  } catch (error) {
    yield put(videosErro('Erro ao excluir vídeo.'));
  }
}

function* toggleAtivoSaga({ payload }) {
  try {
    const result = yield call(patchToggleAtivo, payload.id);
    if (result.response && result.response.status >= 400) {
      yield put(videosErro('Erro ao alterar status do vídeo.'));
    } else {
      yield put(toggleAtivoVideoSucesso());
    }
  } catch (error) {
    yield put(videosErro('Erro ao alterar status do vídeo.'));
  }
}

export function* watchListar() { yield takeEvery(LISTA_VIDEOS, listarSaga); }
export function* watchCriar() { yield takeEvery(CRIA_VIDEO, criarSaga); }
export function* watchEditar() { yield takeEvery(EDITA_VIDEO, editarSaga); }
export function* watchDeletar() { yield takeEvery(DELETA_VIDEO, deletarSaga); }
export function* watchToggleAtivo() { yield takeEvery(TOGGLE_ATIVO_VIDEO, toggleAtivoSaga); }

export default function* rootSaga() {
  yield all([
    fork(watchListar),
    fork(watchCriar),
    fork(watchEditar),
    fork(watchDeletar),
    fork(watchToggleAtivo),
  ]);
}
